import React, { useMemo, useState } from "react";
import ColdStorageKg from "../../../images/material_orange.svg";
import KgEntered from "../../../images/material_kg.svg";
import KgRejected from "../../../images/kg_rejected.svg";
import OrangeTrey from "../../../images/tray_orange.svg";
import DarkOrangeTrey from "../../../images/dark_orange_trey.svg";
import TotalEmployee from "../../../images/total_emp.svg";
import EmployeeUnloading from "../../../images/emp_unloading.svg";
import EmployeeWashing from "../../../images/emp_washing.svg";
import AbsentEmployee from "../../../images/emp_absent.svg";
import DateSelector from "../../../components/shared/fields/DateSelector";
import GridCard from "../../../components/shared/gridCard/GridCard";
import { Col, Row } from "react-bootstrap";
import InfoCard from "../../../components/shared/infocard/InfoCard";
import Button from "../../../components/shared/buttons/button";
import { PlusSvg } from "../../../svgFiles/PlusSvg";
import AddEmployeeModal from "./AddEmployeeModal";
import {
  useGetBrokerageMetricsChartDataQuery,
  useGetBrokeragePackingChartQuery,
  useGetBrokerageSummaryQuery,
} from "../materialEntered/materialApi";
import BrokerageDashboardChart from "./BrokerageDashboardChart";
import { EditSvg } from "../../../svgFiles/EditSvg";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import {
  useGetAllWorkingAreasQuery,
} from "../../../app/globalApi";
import { skipToken } from "@reduxjs/toolkit/query";
import useTranslator from "../../../hooks/useTranslator";
import { formatDateAndTime, getCurrentDate } from "../../../helpers/Utils";
import { PROJECT_DATE_FORMAT } from "../../../helpers/constants";
const BrokerageDashboard = () => {
  const { _t } = useTranslator();  
  const currentDate = getCurrentDate("YYYY-MM-DD");
  const [date, setDate] = useState(currentDate);
  const [showAddEmployment, setShowAddEmployment] = useState(false);
  const [record, setRecord] = useState(false);
  const [packingFilter, setPackingFilter] = useState("monthly");
  const [mode, setMode] = useState("");

  const [matricsFilter, setMatricsFilter] = useState("monthly");
  const { data: employeeSummaryData } = useGetBrokerageSummaryQuery({
    date: date,
    tab: "employees",
  });
  const { data: packingChart } = useGetBrokeragePackingChartQuery({
    filter: packingFilter,
  });

  const { data: summaryData } = useGetBrokerageSummaryQuery({
    tab: "material",
    date,
  });
  const packingChartData = packingChart?.data?.data ?? [];

  const colorMap = {
    "Total Prime": "#ED5E2A",
    "Total Prime Lite": "#25AA91",
    Trash: "#BB001D",
  };

  const formattedPackingData = packingChartData.map((item) => ({
    name: item.name,
    y: item.y,
    color: colorMap[item.name] || "#ccc", // fallback color
  }));

  const totalPrime =
    packingChartData.reduce((acc, item) => acc + item.y, 0) || 0;
  const handleMatricsFilter = (selectedFilter) => {
    setMatricsFilter(filterMap[selectedFilter]);
  };
  const { data: matricsData } = useGetBrokerageMetricsChartDataQuery({
    filter: matricsFilter,
  });

  let filterMap = {
    Today: "hourly",
    Weekly: "weekly",
    Monthly: "monthly",
  };
  const AddEmployee = () => {
    setShowAddEmployment(true);
    setRecord(null);
    setMode("add");
  };
  const EditEmployee = (data) => {
    setShowAddEmployment(true);
    setRecord(data);
    setMode("edit");
  };

  const matrixItems = matricsData?.data?.data ?? [];

  const getValue = (label) => {
    const found = matrixItems.find((item) => item.name === label);
    if (!found) return "0";
    if (label.toLowerCase().includes("percentage")) {
      return `${found.y.toFixed(2)}%`;
    }
    return `${found.y}`;
  };

  const { data: workingAreasData, isLoading: isWorkingAreasLoading } =
    useGetAllWorkingAreasQuery();

  const receivingAreaId = useMemo(() => {
    if (!workingAreasData?.data) return null;
    const receivingArea = workingAreasData.data.find(
      (area) => area.name === "Ripening & Selection Area"
    );
    return receivingArea ? receivingArea.id : null;
  }, [workingAreasData]);

  // const {
  //   data: attendanceOverviewData,
  //   isLoading: isAttendanceLoading,
  //   isError: isAttendanceError,
  // } = useGetAttendanceOverviewQuery(
  //   receivingAreaId
  //     ? { working_area_id: receivingAreaId, date: date }
  //     : skipToken
  // );

  const data = {
    cheeks: [
      {
        label: _t("total_cheeks_kg_prime", "Total Cheeks KG Prime"),
        value: getValue("Total Cheeks KG Prime"),
      },
      {
        label: _t("total_cheeks_kg_waste", "Total Cheeks KG Waste"),
        value: getValue("Total Cheeks KG Waste"),
      },
      {
        label: _t(
          "total_cheeks_prime_percentage",
          "Total Cheeks Prime Percentage"
        ),
        value: getValue("Total Cheeks Prime Percentage"),
      },
    ],
    strips: [
      {
        label: _t("total_strips_kg_prime", "Total Strips KG Prime"),
        value: getValue("Total Strips KG Prime"),
      },
      {
        label: _t("total_strips_kg_waste", "Total Strips KG Waste"),
        value: getValue("Total Strips KG Waste"),
      },
      {
        label: _t(
          "total_strips_prime_percentage",
          "Total Strips Prime Percentage"
        ),
        value: getValue("Total Strips Prime Percentage"),
      },
    ],
  };

  const optionsDonut = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
    },
    title: {
      text: `${totalPrime} <br> ${_t("total_prime", "Total Prime")} <br>`,
      align: "center",
      verticalAlign: "middle",
      y: 60,
      style: {
        fontSize: "1.1em",
      },
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
    },
    accessibility: {
      point: {},
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: false,
        },
        startAngle: -90,
        endAngle: 90,
        center: ["50%", "75%"],
        size: "110%",
        showInLegend: true,
      },
    },
    legend: {
      layout: "horizontal",
      align: "center",
      verticalAlign: "bottom",
      itemMarginBottom: 5,
      itemStyle: {
        color: "#8C97A7",
        fontSize: "14px",
      },
    },
    series: [
      {
        type: "pie",
        name: "Prime Overview",
        innerSize: "50%",
        data: formattedPackingData,
      },
    ],
  };

  const listItems = [
    {
      label: _t("total_kg_entered", "Total KG Entered"),
      value: summaryData?.total_dried_mango_kg ?? 0,
      icon: ColdStorageKg,
    },

    {
      label: _t("total_kg_selected", "Total KG Selected"),
      value: summaryData?.kg_selected ?? 0,
      icon: KgEntered,
    },

    {
      label: _t("total_kg_rejected", "Total KG Rejected"),
      value: summaryData?.total_rejected_kg ?? 0,
      icon: KgRejected,
    },
    {
      label: _t("total_kg_cheeks", "Total KG Cheeks"),
      value: summaryData?.total_cheeks_kg ?? 0,
      icon: OrangeTrey,
    },
    {
      label: _t("total_kg_strips", "Total KG Strips"),
      value: summaryData?.total_strips_kg ?? 0,
      icon: DarkOrangeTrey,
    },
  ];
  const handlePieFilter = (selectedFilter) => {
    setPackingFilter(filterMap[selectedFilter]);
  };

  // const employeelistItems = [
  //   {
  //     label: _t("total_employees", "Total Employees"),
  //     value: employeeSummaryData?.emp_total ?? 0,
  //     icon: TotalEmployee,
  //   },
  //   {
  //     label: _t("employees_in_sorting_area", "Employees in Sorting Area"),
  //     value: employeeSummaryData?.emp_in_sorting_area ?? 0,
  //     icon: EmployeeUnloading,
  //   },
  //   {
  //     label: _t("employee_in_packing_area", "Employee in Packing Area"),
  //     value: employeeSummaryData?.emp_in_packing_area ?? 0,
  //     icon: EmployeeWashing,
  //   },
  //   {
  //     label: _t("absent_employees", "Absent Employees"),
  //     value: employeeSummaryData?.absent_emp ?? 0,
  //     icon: AbsentEmployee,
  //   },
  // ];

  // const attendanceListItems = useMemo(() => {
  //   if (!attendanceOverviewData?.data) return [];

  //   const items = [
  //     {
  //       label: _t("total_employees", "Total Employees"),
  //       value: attendanceOverviewData.data.total_employees,
  //       icon: TotalEmployee,
  //     },
  //   ];

  //   for (const [role, count] of Object.entries(
  //     attendanceOverviewData.data.roles
  //   )) {
  //     items.push({
  //       label: role.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()), // format label
  //       value: count,
  //       icon: EmployeeUnloading,
  //     });
  //   }

  //   return items;
  // }, [attendanceOverviewData]);

  return (
    <div>
      {showAddEmployment && (
        <AddEmployeeModal
          show={showAddEmployment}
          setShow={setShowAddEmployment}
          record={record}
          mode={mode}
        />
      )}{" "}
      <div className="overview cmn_card mb-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">{_t("overview", "Overview")}</h6>
          <div className="d-flex gap-2 align-items-center">
            <DateSelector setDate={setDate} />
          </div>
        </div>
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date ,PROJECT_DATE_FORMAT)}
            />
          ))}
        </ul>
      </div>
      <BrokerageDashboardChart />
      <Row className="mt-3 mb-3 h-100">
        <Col lg={6}>
          <div className="cmn_card">
            <div className="overview_header d-flex gap-2 align-items-center">
              <h6 className="mb-0 flex-grow-1">Packing Overview</h6>
              <ul className="chart_filter">
                {["Today", "Weekly", "Monthly"].map((item, index) => (
                  <li
                    key={index}
                    onClick={() => handlePieFilter(item)}
                    className={
                      filterMap[item] === packingFilter ? "active" : ""
                    }
                  >
                    {_t(item, item)}
                  </li>
                ))}
              </ul>
            </div>
            <div className="p-2">
              <HighchartsReact highcharts={Highcharts} options={optionsDonut} />
            </div>
          </div>
        </Col>
        <Col lg={6}>
          <div className="cmn_card h-100">
            <div className="overview_header d-flex gap-2 align-items-center ">
              <h6 className="mb-0 flex-grow-1  ">
                {_t("matrix_overview", "Matrix Overview")}
              </h6>
              <ul className="chart_filter">
                {["Today", "Weekly", "Monthly"].map((item, index) => (
                  <li
                    key={index}
                    onClick={() => handleMatricsFilter(item)}
                    className={
                      filterMap[item] === matricsFilter ? "active" : ""
                    }
                  >
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="p-2 position-relative">
              <Row>
                <Col lg={6} className="border-end">
                  <h6 className="my-3">{_t("cheeks", "Cheeks")}</h6>

                  <Row>
                    {data.cheeks.map((item, index) => (
                      <Col lg={12} key={index}>
                        <InfoCard label={item.label} value={item.value} />
                      </Col>
                    ))}
                  </Row>
                </Col>
                <Col lg={6}>
                  <h6 className="my-3">{_t("strips", "Strips")}</h6>
                  <Row>
                    {data.strips.map((item, index) => (
                      <Col lg={12} key={index}>
                        <InfoCard label={item.label} value={item.value} />
                      </Col>
                    ))}
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default BrokerageDashboard;
